import axios from 'axios'

export const url = "https://ghbazargan.com/api/v1"
export const baseurl = "https://ghbazargan.com"






export const getSansinfobyID = (concertID) => {
    let formdata = new FormData()
    formdata.append('concert_id', concertID)
    return axios.post(`${url}/sans`, formdata)

}









// ---------------------------- Safiran---------------------------
export const getSplash = ( ) => {
    return axios.get(`${url}/splash`)
}

export const getNews = (config) => {
    return axios.get(`${url}/news`, config)
}

export const getBlogs = (config ) => {
    return axios.get(`${url}/news`,config)
}
export const getBlog = (config ) => {
    return axios.get(`${url}/new`,config)
}

export const getProducts = (config ) => {
    return axios.get(`${url}/products`,config)
}


export const getProduct = (config ) => {
    return axios.get(`${url}/product`,config)
}








